"use client";
import "./App.css";
import { Button } from "./components/ButtonElement";
import { useState } from "react";
import { ThemeProvider } from "styled-components";
import { Theme } from "./components/WebsiteThemeElements";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { Welcome } from "./components/Navbar/Data";
import InfoSection from "./components/InfoSection";
import { homeObj2 } from "./components/InfoSection/Data";
import WelcomePage from "./components/WelcomPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WebsiteThemeProvider from "./components/WebsiteTheme/WebsiteThemeContext";
import About from "./components/About";
import AlertProvider from "./components/Alert/AlertContext";
import SignUpPage from "./components/SignUp";
import { XRPLWalletProvider } from "./hooks/xrplAppKit/XRPLWalletProvider";
import { JoeyWalletProvider } from "./hooks/xrplAppKit/joeyWallet/JoeyWalletProvider";
import { AuthProvider } from "./contexts/AuthContext";
import SignInPage from "./components/Login";
import Dashboard from "./components/Dashboard";
import SwerlStore from "./components/SwerlStore";
import { ModalProvider } from "./components/Modal/ModalContext";

export function Home() {
  const [hover, setHover] = useState(false);
  const onHover = () => {
    setHover(!hover);
  };
  return (
    <>
      <WelcomePage {...homeObj2} />
    </>
  );
}

export default function App() {
  return (
    <Router>
      {" "}
      <XRPLWalletProvider>
        <JoeyWalletProvider>
          <AuthProvider>
            <WebsiteThemeProvider>
              <AlertProvider>
                <ModalProvider>
              
                <Navbar navInfo={Welcome} />
                <Routes>
                  <Route exact path="/" element={<Home />} />
                  <Route exact path="/signup" element={<SignUpPage />} />
                   <Route exact path="/signin" element={<SignInPage/>} /> 
                   {/* <Route exact path="/home" element={<Dashboard/>} /> */} 
                  <Route exact path="/about" element={<About />} />
                  <Route exact path="/store" element={<SwerlStore />} />
                  <Route exact path="*" element={<Home />} />
                </Routes>
                <Footer />
              </ModalProvider>
              </AlertProvider>
            </WebsiteThemeProvider>
          </AuthProvider>
        </JoeyWalletProvider>
      </XRPLWalletProvider>
    </Router>
  );
}
